import { WORK_MAKER_AVAILABLE_DRILL_TYPE } from "../constants/work-maker";
import { availableDrillTypeIdListFromSchool } from "./Drill";
/**
 * ユーザーの学校種からワークメーカーで使用可能なドリルタイプを返す
 *
 * @param schoolType 学校種
 */
export var getWorkMakerAvailableDrillTypeListFromSchoolType = function (schoolType) {
    return availableDrillTypeIdListFromSchool(schoolType).filter(function (drillType) {
        return WORK_MAKER_AVAILABLE_DRILL_TYPE.some(function (_availableDrillType) { return _availableDrillType === drillType; });
    });
};
